/**
 * @generated SignedSource<<3c0c6e6e3e17172e28440cb27a5518b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
import { FragmentRefs } from "relay-runtime";
export type AutoRecordToggle_note$data = {
  readonly event: {
    readonly hasUsersWithExternalEmail: boolean;
    readonly willBeRecorded: WillBeRecordedType;
  } | null;
  readonly stream: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AutoRecordToggle_refetchableAutoRecordIsOnForStream" | "AutoRecordToggle_refetchableAutoRecordReason">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AutoSendToEveryone_autoShareIsSetToEveryone_note">;
  readonly " $fragmentType": "AutoRecordToggle_note";
};
export type AutoRecordToggle_note$key = {
  readonly " $data"?: AutoRecordToggle_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordToggle_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordToggle_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordToggle_refetchableAutoRecordReason"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AutoRecordToggle_refetchableAutoRecordIsOnForStream"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasUsersWithExternalEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "willBeRecorded",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "AutoSendToEveryone_autoShareIsSetToEveryone_note",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteStream",
          "kind": "LinkedField",
          "name": "stream",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "meetingRecapAutoShareSource",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_S",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "StreamMeetingRecapAutoShareSettings",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_U",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "UserMeetingRecapAutoShareSettings",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "226a603b38f76e1a9e1b25d99fb672b7";

export default node;
